/**
 * @generated SignedSource<<128993eec7a15f16b2a20a32e8ab7f92>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubService = "CLICK_N_COLLECT" | "INSTANT_BUY" | "LOCK_B2B" | "LOCK_B2C" | "ONEDELIVERY" | "RAFFLE" | "SHOP_N_COLLECT" | "%future added value";
export type instantBuyCatalogueQuery$variables = {
  hubName: string;
};
export type instantBuyCatalogueQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly lat: number;
        readonly lng: number;
        readonly name: string;
        readonly services: ReadonlyArray<HubService>;
      };
      readonly products: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly product: {
            readonly brand: {
              readonly id: string;
              readonly organization: {
                readonly id: string;
                readonly name: string;
              };
            };
            readonly category: {
              readonly i18N: any;
              readonly id: string;
              readonly name: string;
            } | null | undefined;
            readonly id: string;
            readonly name: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"ProductDrawerFragment">;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"ProductTrackFragment">;
      };
      readonly slug: string;
    };
    readonly id: string;
    readonly name: string;
    readonly organization: {
      readonly id: string;
      readonly slug: string;
    };
    readonly street: string;
  };
};
export type instantBuyCatalogueQuery = {
  response: instantBuyCatalogueQuery$data;
  variables: instantBuyCatalogueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "services",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "active": true
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "category",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "i18N",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stock",
  "storageKey": null
},
v11 = {
  "name": "outOfStock",
  "args": null,
  "fragment": {
    "kind": "InlineFragment",
    "selections": [
      (v10/*:: as any*/)
    ],
    "type": "HubProduct",
    "abstractKey": null
  },
  "kind": "RelayResolver",
  "storageKey": null,
  "isOutputType": true
},
v12 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "HubMeta"
},
v13 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v14 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
},
v15 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v16 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v17 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Organization"
},
v18 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "instantBuyCatalogueQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v6/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "hub",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "kind": "RequiredField",
                    "field": (v7/*:: as any*/),
                    "action": "THROW"
                  },
                  {
                    "alias": null,
                    "args": (v8/*:: as any*/),
                    "concreteType": "HubProductPage",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProductTrackFragment"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubProduct",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Brand",
                                "kind": "LinkedField",
                                "name": "brand",
                                "plural": false,
                                "selections": [
                                  (v2/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Organization",
                                    "kind": "LinkedField",
                                    "name": "organization",
                                    "plural": false,
                                    "selections": [
                                      (v2/*:: as any*/),
                                      (v3/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProductDrawerFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "products(filter:{\"active\":true})"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "instantBuyCatalogueQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": (v8/*:: as any*/),
                "concreteType": "HubProductPage",
                "kind": "LinkedField",
                "name": "products",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubProduct",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v10/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "priceAmount",
                        "storageKey": null
                      },
                      (v11/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v3/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Brand",
                            "kind": "LinkedField",
                            "name": "brand",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Organization",
                                "kind": "LinkedField",
                                "name": "organization",
                                "plural": false,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v3/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "imprint",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloudflareImage",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "variant",
                                    "value": "PUBLIC"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "variant",
                                "storageKey": "variant(variant:\"PUBLIC\")"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v11/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "products(filter:{\"active\":true})"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90f8f852deae07ccf483782a0cac71d7",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": (v12/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v13/*:: as any*/),
        "hubMeta.hub.meta": (v12/*:: as any*/),
        "hubMeta.hub.meta.id": (v13/*:: as any*/),
        "hubMeta.hub.meta.lat": (v14/*:: as any*/),
        "hubMeta.hub.meta.lng": (v14/*:: as any*/),
        "hubMeta.hub.meta.name": (v15/*:: as any*/),
        "hubMeta.hub.meta.services": {
          "enumValues": [
            "INSTANT_BUY",
            "ONEDELIVERY",
            "CLICK_N_COLLECT",
            "RAFFLE",
            "LOCK_B2B",
            "LOCK_B2C",
            "SHOP_N_COLLECT"
          ],
          "nullable": false,
          "plural": true,
          "type": "HubService"
        },
        "hubMeta.hub.products": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "HubProductPage"
        },
        "hubMeta.hub.products.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "HubProduct"
        },
        "hubMeta.hub.products.nodes.id": (v13/*:: as any*/),
        "hubMeta.hub.products.nodes.priceAmount": (v16/*:: as any*/),
        "hubMeta.hub.products.nodes.product": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Product"
        },
        "hubMeta.hub.products.nodes.product.brand": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Brand"
        },
        "hubMeta.hub.products.nodes.product.brand.id": (v13/*:: as any*/),
        "hubMeta.hub.products.nodes.product.brand.name": (v15/*:: as any*/),
        "hubMeta.hub.products.nodes.product.brand.organization": (v17/*:: as any*/),
        "hubMeta.hub.products.nodes.product.brand.organization.id": (v13/*:: as any*/),
        "hubMeta.hub.products.nodes.product.brand.organization.imprint": (v18/*:: as any*/),
        "hubMeta.hub.products.nodes.product.brand.organization.name": (v15/*:: as any*/),
        "hubMeta.hub.products.nodes.product.category": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Category"
        },
        "hubMeta.hub.products.nodes.product.category.i18N": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "CategoryI18N"
        },
        "hubMeta.hub.products.nodes.product.category.id": (v13/*:: as any*/),
        "hubMeta.hub.products.nodes.product.category.name": (v15/*:: as any*/),
        "hubMeta.hub.products.nodes.product.description": (v18/*:: as any*/),
        "hubMeta.hub.products.nodes.product.id": (v13/*:: as any*/),
        "hubMeta.hub.products.nodes.product.name": (v15/*:: as any*/),
        "hubMeta.hub.products.nodes.product.photo": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "CloudflareImage"
        },
        "hubMeta.hub.products.nodes.product.photo.id": (v15/*:: as any*/),
        "hubMeta.hub.products.nodes.product.photo.variant": (v15/*:: as any*/),
        "hubMeta.hub.products.nodes.stock": (v16/*:: as any*/),
        "hubMeta.hub.slug": (v15/*:: as any*/),
        "hubMeta.id": (v13/*:: as any*/),
        "hubMeta.name": (v15/*:: as any*/),
        "hubMeta.organization": (v17/*:: as any*/),
        "hubMeta.organization.id": (v13/*:: as any*/),
        "hubMeta.organization.slug": (v15/*:: as any*/),
        "hubMeta.street": (v15/*:: as any*/)
      }
    },
    "name": "instantBuyCatalogueQuery",
    "operationKind": "query",
    "text": "query instantBuyCatalogueQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    organization {\n      id\n      slug\n    }\n    hub {\n      id\n      slug\n      meta {\n        id\n        name\n        services\n        lat\n        lng\n      }\n      products(filter: {active: true}) {\n        ...ProductTrackFragment\n        nodes {\n          id\n          product {\n            id\n            name\n            brand {\n              id\n              organization {\n                id\n                name\n              }\n            }\n            category {\n              id\n              name\n              i18N\n            }\n          }\n          ...ProductDrawerFragment\n        }\n      }\n    }\n  }\n}\n\nfragment ProductCardFragment on HubProduct {\n  id\n  priceAmount\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n  stock\n  ...clientResolversOutOfStockFragment\n}\n\nfragment ProductDrawerFragment on HubProduct {\n  id\n  priceAmount\n  stock\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n      organization {\n        id\n        name\n        imprint\n      }\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n}\n\nfragment ProductTrackFragment on HubProductPage {\n  nodes {\n    id\n    stock\n    priceAmount\n    ...clientResolversOutOfStockFragment\n    product {\n      id\n      name\n      brand {\n        id\n        organization {\n          id\n          name\n        }\n      }\n      category {\n        id\n        name\n      }\n    }\n    ...ProductCardFragment\n  }\n}\n\nfragment clientResolversOutOfStockFragment on HubProduct {\n  stock\n}\n"
  }
};
})();

(node as any).hash = "d122a20122add368b93cec283500372c";

export default node;
